import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=590d41db&"
import script from "./Dossier.vue?vue&type=script&lang=ts&"
export * from "./Dossier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports